import { createFileRoute } from "@tanstack/react-router";
import { ScrollAreaExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/radix/scroll-area")({
  component: ScrollAreaExamples,
});
